const dir: Vector3 = new window.v3d.Vector3();

export const computeDirectionIn3D = (p1: Vector3, p2: Vector3) =>
  dir.copy(p2).sub(p1);
